import React from 'react'
import { SvgIconProps } from './Home'

const ArchiveIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "32"}
    height={height ?? "32"}
    fill="none"
    viewBox="0 0 32 32"
  >
    <path
      fill={fill ?? "#353535"}
      stroke={fill ?? "#353535"}
      strokeWidth="0.5"
      d="M30 6.75H16.5v-2.5a1 1 0 00-1-1h-12a1 1 0 00-1 1v2.5H2a1 1 0 00-1 1v20a1 1 0 001 1h28a1 1 0 001-1v-20a1 1 0 00-1-1zM4.5 5.25h10v1.5h-10v-1.5zM29 26.75H3v-18h26v18z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      stroke={fill ?? "#353535"}
      strokeWidth="0.5"
      d="M15 12v6.85l-1.945-1.56a1 1 0 10-1.25 1.56l3.57 2.86.065.035c.04.031.081.06.125.085l.075.025h.07a.866.866 0 00.58 0h.07l.075-.025c.043-.025.085-.054.125-.085l.065-.035 3.57-2.86a1 1 0 10-1.25-1.56L17 18.85V12a1 1 0 10-2 0zM10 24.19a1 1 0 001 1h10a1 1 0 000-2H11a1 1 0 00-1 1z"
    ></path>
  </svg>
)

export default ArchiveIcon
